import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";


import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addRatersTypeText, editRatersTypeText } from "store/actions";
import { fetchLanguageList } from "helpers/backend_api_helper";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";

const TextAddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchRatersTypeTextListData, tableData } = props
    const [ratersTypeTextData, setRatersTypeTextData] = useState();
    const [languageList, setLanguageList] = useState()
    const { state } = useLocation();

    const { error, success, loading,editLoading } = useSelector(state => ({
        loading: state.configRatersType.loading,
        error: state.configRatersType.error,
        success: state.configRatersType.success,
        editLoading:state.configRatersType.editLoading

    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setRatersTypeTextData(itemData)
    }, [itemData])

    // fetch language
    const fetchLanguageLists = async () => {
        const listLang = await fetchLanguageList();
        setLanguageList(listLang?.data)
    }

    useEffect(() => {
        fetchLanguageLists()
    }, [])

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            language_id: ratersTypeTextData?.language_id || languageList && languageList[0]?.id,
            rater_text: ratersTypeTextData?.rater_text || '',
            is_active: ratersTypeTextData?.is_active || 'Y'
        },
        validationSchema: Yup.object({
            language_id: Yup.string().required(props.t("Please Enter Language")),
            rater_text: Yup.string().required(props.t("Please Enter Text")),
            is_active: Yup.string().required(props.t("Please Enter Text Status")),
        }),
        onSubmit: (values, { resetForm }) => {
            values = {
                ...values,
                rater_id: state?.ratersTypeData?.id
            }
            if (isEdit) {
                const languageExists = tableData?.raters_type_text?.some(item => item.language_id == Number(values.language_id) && values.language_id != itemData.language_id);
                if(languageExists){
                    return toastr.error("Rater text already exists with the selected language.")
                }

                dispatch(editRatersTypeText(values, ratersTypeTextData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            language_id: '',
                            rater_text: '',
                            is_active: ''
                        });
                        fetchRatersTypeTextListData();
                        toggle()

                    } else {
                        toastr.error(res.message)
                        toggle()
                        
                    }
                }));
            } else {
                const languageExists = tableData?.raters_type_text?.some(item => item.language_id == values.language_id);

                if(languageExists){
                    return toastr.error("Rater text already exists with the selected language.")
                }

                dispatch(addRatersTypeText(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {
                        
                        resetForm({
                            language_id: '',
                            rater_text: '',
                            is_active: ''
                        });
                        fetchRatersTypeTextListData()
                        toastr.success(res.message)
                        toggle()
                    } else {
                        toastr.error(res.message)
                        toggle()
                        
                    }
                }));
            }
        }
    });

    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        
                    }}>
                    {!!isEdit ? props.t("Edit Raters Text") : props.t("Add Raters Text")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        {/* <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Raters Concept id")}: </Label>
                            <span style={{ fontSize: "15px", fontWeight: "bold" }}> {state?.ratersTypeData?.rater_text}</span>
                        </div> */}

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Language")}:</Label>
                            <Input
                                name="language_id"
                                className="form-control"
                                type="select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.language_id || ""}
                                invalid={
                                    validation.touched.language_id && validation.errors.language_id ? true : false
                                }
                            >
                                <option value="" disabled>{props.t("Select Language")}</option>
                                {
                                    languageList?.map((data, key) => {
                                        return (
                                            <option key={key} value={data?.id}>{data?.label}</option>
                                        )
                                    })
                                }
                            </Input>
                            {validation.touched.language && validation.errors.language ? (
                                <FormFeedback type="invalid">{validation.errors.language}</FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3 d-block">

                            <Label className="form-label m-0 pb-1">{props.t("Text")}:</Label>

                            <Input
                                type="text"
                                name="rater_text"
                                placeholder={props.t("Enter Text")}
                                value={validation.values.rater_text || ""}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.rater_text && validation.errors.rater_text ? true : false}
                            >
                            </Input>

                            {validation.touched.rater_text && validation.errors.rater_text ? (
                                <FormFeedback type="invalid">{validation.errors.rater_text}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="yes"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active == 'Y' ? true : false}
                                    value="Y"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="yes" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="no"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N' ? true : false}
                                    value="N"
                                    type="radio"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="no" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div>

                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }

                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


TextAddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(TextAddEditModal);
